import { render, staticRenderFns } from "./PostLabels.vue?vue&type=template&id=603670e5"
import script from "./PostLabels.vue?vue&type=script&lang=js"
export * from "./PostLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports